export const EMPLOYEE_DATA_SUCCESS = 'EMPLOYEE_DATA_SUCCESS';
export const EMPLOYEE_DATA_LOADING = 'EMPLOYEE_DATA_LOADING';
export const EMPLOYEE_DATA_FAILED  = 'EMPLOYEE_DATA_FAILED';
